import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { AnnotationApiModel } from "@modules/annotation/types.ts";
import { MediaObjectMetadataModel, UserGenerateContentPreviewModel } from "@plugins/media/types.ts";

const fetchAnnotation = (requestData): Promise<ApiResponse<AnnotationApiModel[]>> => {
  return httpClient.get(`/apis/annotation/get-annotation`, {
    params: requestData,
  });
};

const createAnnotation = (requestData): Promise<ApiResponse<AnnotationApiModel>> => {
  return httpClient.post(`/apis/annotation/create`, requestData, {
    headers: {
      "X-With-Richtext": true,
    },
  });
};

const deleteAnnotation = async (uuid): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/apis/annotation/delete/${uuid}`);
};

const updateAnnotationContent = async (
  uuid,
  requestData,
): Promise<ApiResponse<AnnotationApiModel>> => {
  return await httpClient.post(`/apis/annotation/update-content/${uuid}`, requestData, {
    headers: {
      "X-With-Richtext": true,
    },
  });
};

const toggleAnnotationComment = async (params): Promise<ApiResponse<AnnotationApiModel>> => {
  return await httpClient.post(
    `/apis/annotation/comment/toggle/${params.annotationUuid}/${params.toggleStatus}`,
  );
};

const fetchMediaObjectByAnchor = async (uuid): Promise<ApiResponse<MediaObjectMetadataModel>> => {
  return await httpClient.get(`/apis/mediaobject/get-meta/annotation/${uuid}`);
};

const fetchUgcByAnchor = async (uuid): Promise<ApiResponse<UserGenerateContentPreviewModel>> => {
  return await httpClient.get(`/apis/ugc/get-meta/annotation/${uuid}`);
};

export default {
  fetchAnnotation,
  createAnnotation,
  deleteAnnotation,
  updateAnnotationContent,
  toggleAnnotationComment,
  fetchMediaObjectByAnchor,
  fetchUgcByAnchor,
};
